<app-ui-field [label]="label()" [hideLabel]="hideLabel()" [inputId]="inputId">
  <app-ui-combobox
    [indicatorIcon]="suggested() ? 'lucideSparkles' : null"
    [suggested]="suggested()"
    class="select-bucket-typeahead"
    appearance="outline"
    [inputId]="inputId"
    [placeholder]="placeholder() || label()"
    searchPlaceholder="Search Budgets"
    emptyText="No matching budgets"
    [options]="bucketOptions()"
    [value]="selectedBucketOption()"
    [(open)]="panelOpen"
    (valueChange)="onBucketOptionChange($event)"
  />
</app-ui-field>
